import { Pipe, PipeTransform } from '@angular/core';
import { RiskService } from '../services/risk.service';

@Pipe({ name: 'riskImpact' })
export class RiskImpactPipe implements PipeTransform {
	
	constructor(private riskService: RiskService) {	}
	
	transform(value: any) {
		const impact = this.riskService.riskImpacts.find(x => value >= x.min && value <= x.max);

		if (impact) {
			return impact.label;
		}

		return value;
	}
}
